// Components
import { Splash, BuyCrypto, OwnedCrypto, WhoAreWe } from './components'
import { StatField } from 'components/statField'
import { Icon } from 'components/icon'

// Styles
import {
  CardDuo,
  CardGrid,
  IconContainer,
  IconStatCard,
} from './homePage.styles'

// Constants
import { getCards } from './homePage.constants'

// Providers
import { useSafePOKTContext } from 'providers/SafePOKTProvider'

// Hooks
import { useReady, useBridge } from 'hooks/useReady'
import { SafePoktParams, SafePoktUserParams } from 'hooks/useSafePOKT'
import { getPoktPrice } from 'hooks/useSafePOKT/useSafePOKT.utils'
// Utils
import { numberFormatter } from 'utils'

import { useEffect, useState } from 'react'

export const HomePage = () => {
  const state = useSafePOKTContext()
  const isReady = useReady()
  const isBridge = useBridge()
  const [poktPrice, setPoktPrice] = useState(state.poktBuyPrice)
  useEffect(() => {
    const queryPoktPrice = async () => {
        const price = (await getPoktPrice()) as number
        if (price !== 0) setPoktPrice(price)
        else setPoktPrice(state.poktBuyPrice)
    }
    queryPoktPrice()
  }, [state.poktBuyPrice])

  return (
    <>
      <Splash />
      <WhoAreWe />

      <CardGrid breakpoints={{ xs: 1, s: 2, m: 2, l: 2, xl: 5 }}>
        {getCards(poktPrice, state.totalPOKTStake, state.getPoktPerShare, state.epochDuration, state.nextEpochDateMS).map(
          ({ label, key, subStat, icon, info, statConfig, subStatConfig, fractionDigits }) => (
            <IconStatCard key={label}>
              <StatField
                label={label}
                stat={{
                  value: statConfig?.notANumber
                    ? ((typeof key === "number")?key.toString():state[key].toString())
                    : numberFormatter({
                        number: (typeof key === "number")?key:Number(state[key]),
                        unit: statConfig?.unit,
                        isPrefix: statConfig?.prefix,
                        maxFractionDigits: (fractionDigits === 0) ? 0 : (fractionDigits ? fractionDigits : 1),
                      }),
                  token: statConfig?.token,
                }}
                isSubStaHighlighted={subStatConfig?.bold}
                subStat={
                  subStat &&
                  numberFormatter({
                    number: subStat((typeof key === "number")?key:Number(state[key])),
                    unit: subStatConfig?.unit,
                    isPrefix: subStatConfig?.prefix,
                    maxFractionDigits: 2,
                  })
                }
                isLoading={state.isLoading || key === -1}
                info={info}
              />
              {icon && (
                <IconContainer>
                  <Icon icon={icon} />
                </IconContainer>
              )}
            </IconStatCard>
          )
        )}
      </CardGrid>
      <CardDuo>
        <OwnedCrypto
          isDisabled={
            !isReady ||
            !(
              state[SafePoktUserParams.Exists] &&
              state[SafePoktParams.HolderActionsEnabled]
            )
          }
          isLoading={state.isLoading}
        />
        <BuyCrypto
          isDisabled={!isReady || !state[SafePoktParams.HolderActionsEnabled]}
          isDisabledEth={!isBridge || !state[SafePoktParams.HolderActionsEnabled]}
          realPoktPrice={poktPrice}
        />
      </CardDuo>
    </>
  )
}
